export const PARTNER_PROJECT_STATUSES = [
  'Sales Cycle / Not Started',
  'Active',
  'Go-Live Complete',
  'Completed',
  'At Risk',
  'Info Requested',
];

export const PARTNER_PRIMARY_STATUSES = {
  NOT_STARTED: 'Sales Cycle / Not Started',
  ACTIVE: 'Active',
  GOLIVE: 'Go-Live Complete',
  COMPLETED: 'Completed',
  AT_RISK: 'At Risk',
  INFO_REQUESTED: 'Info Requested',
};
